import React from 'react';
import mainLogo from '../../../../assets/main_logo.png';
import './SLoader.css';

interface SLoaderProps {
  className?: string;
}

const SLoader: React.FC<SLoaderProps> = ({ className = '' }) => {
  const maskStyle = {
    maskImage: `url(${mainLogo})`,
    WebkitMaskImage: `url(${mainLogo})`,
    maskSize: 'contain',
    WebkitMaskSize: 'contain',
    maskRepeat: 'no-repeat',
    WebkitMaskRepeat: 'no-repeat',
    maskPosition: 'center',
    WebkitMaskPosition: 'center',
  } as React.CSSProperties;

  return (
    <div className={`s-loader ${className}`}>
      <div className="s-loader__wrap">
        {/* Muted base — always visible, shows logo shape */}
        <div className="s-loader__base" style={maskStyle} />
        {/* Gold fill — rises from bottom */}
        <div className="s-loader__fill" style={maskStyle} />
      </div>
    </div>
  );
};

export default SLoader;
